<template>
	<div>
		<flCabecalhoForm
			class="print-titulo-form-20"
			:texto="_traducao('global', 'vitimas')"
		/>
		<div class="row" style="display: flex; flex-wrap: wrap">
			<div
				class="col-lg-3 col-md-4 col-xs-12"
				v-for="(item, index) in formVitimas"
				:key="index"
				style="min-height: 260px; display: flex"
				v-if="item.tipo == 'V'"
			>
				<div class="trecho-borda" style="margin-bottom: 10px; width: 100%">
					<div class="row">
						<div class="col-xs-12 form-group">
							<label style="color: #1976d2">
								{{ _traducao('global', 'vitima').toUpperCase() }}
							</label>
							<a
								href="#"
								class="pull-right"
								@click.prevent="removePass(item, index, 1)"
								style="color: red; font-size: 14px; margin-top: 2px"
							>
								<i class="fa fa-fw fa-trash-o"></i
								>{{ _traducao('global', 'remover') }}
							</a>
						</div>
					</div>
					<div class="row" style="margin-bottom: 10px">
						<div class="col-md-12">
							<label>{{ _traducao('global', 'vitimaFoiIdentificada') }}</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<flSimNao v-model="item.vitimaIdentificada" />
							</div>
						</div>
					</div>
					<div class="row" v-if="Number(item.vitimaIdentificada)">
						<div
							class="col-xs-12 form-group"
							:class="{'has-error': item.nomeErro}"
						>
							<label>* {{ _traducao('global', 'nome') }}:</label>
							<input
								type="text"
								v-model="item.nome"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="item.nomeErro">
								{{ item.nomeErro }}
							</p>
						</div>
					</div>
					<div class="row" v-if="Number(item.vitimaIdentificada)">
						<div class="col-xs-12 form-group">
							<label>CPF:</label>
							<input
								type="text"
								v-model="item.cpf"
								v-mask="_vdocumento"
								class="form-control input-sm"
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-3 col-md-4 col-xs-12" style="display: flex">
				<div
					class="trecho-borda text-center add"
					@click="clickAdicionaPassageiro()"
					style="
						margin-bottom: 10px;
						cursor: pointer;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						min-height: 260px;
					"
				>
					<h3>
						{{ _traducao('global', 'adicionar').toUpperCase() }}
						<br />
						{{ _traducao('global', 'vitima').toUpperCase() }}
						<BR />
						<i class="fa fa-fw fa-plus" />
					</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $carrega from '../mixins/carrega.js'
export default {
	name: 'ComponenteTempoVoo',
	mixins: [$carrega],
	props: {
		form: {
			default() {
				return []
			},
			type: Array,
			required: true
		}
	},
	data() {
		return {
			formVitimas: []
		}
	},
	methods: {
		removePass(item, index, qtd) {
			this.$emit('excluir-vitimas', item, index, qtd)
		},

		clickAdicionaPassageiro() {
			this.$emit('atualiza-vitimas', 'V')
		}
	},
	computed: {
		__exibeVitimas() {
			return this.formVitimas.filter((passageiro) => {
				return passageiro.tipo == 'V'
			})
		}
	},
	watch: {
		form: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.formVitimas = this.form
				}
			}
		}
	}
}
</script>